import {
  Table,
  TableColumn,
  Form,
  FormItem,
  Row,
  Col,
  Select,
  Option,
  Checkbox,
  RadioGroup,
  Radio,
  Input,
  Dialog,
  Button,
  Steps,
  Step,
  Popover,
  Upload,
  Pagination,
  DatePicker,
  Alert,
  Message,
  MessageBox,
  Loading
} from '@jd/element-ui'

const components = [
  Table,
  TableColumn,
  Form,
  FormItem,
  Row,
  Col,
  Select,
  Option,
  Checkbox,
  RadioGroup,
  Radio,
  Input,
  Dialog,
  Button,
  Steps,
  Step,
  Upload,
  Pagination,
  DatePicker,
  Popover,
  Alert
]

const install = Vue => {
  if (install.installed) {
    return
  }
  components.forEach(component => {
    Vue.component(component.name, component)
  })
  Vue.use(Loading.directive)
  Vue.$loading = Vue.prototype.$loading = Loading.service
  Vue.prototype.$jcmsgbox = MessageBox
  Vue.$jcalert = Vue.prototype.$jcalert = MessageBox.alert
  Vue.prototype.$jcconfirm = MessageBox.confirm
  Vue.prototype.$jcprompt = MessageBox.prompt
  Vue.prototype.$jcmessage = Message
}
export default {
  install
}
